/*
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-06-11 15:00:44
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-08-19 14:25:05
 * @FilePath: \website_vue1\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Privacy from '@/views/privacyPolicy.vue'


import clinicalDetail from '@/views/clinicalDetail.vue'

import productDetail from '@/views/productDetail.vue'
Vue.use(Router)

const router = new Router({
    mode: 'history', // 使用 HTML5 history 模式（URL 无 #）
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/productDetail',
            name: 'productDetail',
            component: productDetail
        },
        {
            path: '/clinicalDetail',
            name: 'clinicalDetail',
            component: clinicalDetail
        },

        {
            path: '/about',
            name: 'About',
            component: About
        },

        {
            path: '/privacyPolicy',
            name: 'Privacy',
            component: Privacy
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        console.log(to);
        console.log(from);
        console.log(savedPosition);
        // 每次路由切换回到顶部
        return { x: 0, y: 0 }
    }
})

export default router
